import React from 'react';

import { Spinner } from '@iwoca/orion';
import ReactDOM from 'react-dom';

class Select extends React.Component {
    static defaultProps = {
        tabIndex: '-1'
    };

    state = {
        value: this.props.value || ''
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            this.setState({ value: nextProps.value });
        }
    }

    onChange = (e) => {
        const value = this.props.formatter
            ? this.props.formatter(e.target.value)
            : e.target.value;
        this.setState({ value });
        this.props.onChange(value);
    };

    onClick = () => {
        this.props.onClick(this.state.value);
    };

    componentDidUpdate(prevProps) {
        if (!prevProps.isSearching) {
            // eslint-disable-next-line react/no-find-dom-node, react/no-string-refs
            let input = ReactDOM.findDOMNode(this.refs.input);
            input.querySelector('input') &&
                input.querySelector('input').focus();
        }
    }

    renderIcon = () => {
        const { isLoading } = this.props;
        return !isLoading ? (
            <span className="search-btn">Search</span>
        ) : (
            <Spinner size="small" />
        );
    };

    renderSelect = () => {
        const {
            onFocus,
            onBlur,
            placeholder,
            onKeyDown,
            handleClick,
            isSearching
        } = this.props;

        return !isSearching ? (
            <div className="input-group right">
                <div
                    className="form-control has-values"
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onClick={handleClick}
                    placeholder={placeholder || 'Search...'}>
                    <span className="holder">
                        <span className="text">{this.state.value}</span>
                    </span>
                </div>
                <span
                    className="input-group-addon"
                    onClick={handleClick}
                    tabIndex="-1"
                    onFocus={onFocus}
                    onBlur={onBlur}>
                    <span className="search-btn">Edit</span>
                </span>
            </div>
        ) : (
            <div className="input-group right">
                <input
                    className="form-control"
                    value={this.state.value}
                    onKeyDown={onKeyDown}
                    onChange={this.onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    autoComplete="off"
                    onClick={handleClick}
                    placeholder={placeholder || 'Search...'}
                />
                <span className="input-group-addon" onClick={this.onClick}>
                    {this.renderIcon()}
                </span>
            </div>
        );
    };

    render() {
        // eslint-disable-next-line react/no-string-refs
        return <div ref="input">{this.renderSelect()}</div>;
    }
}

export default Select;
